if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    
    $('.reviews').slick({
        fade:true,
        accessibility: false,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows:false,
                dots: true,
                adaptiveHeight:true
              }
            }
        ]
    });

    $('.sym-slides-review').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });

      //Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).closest('.inner').removeClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$(this).next().slideUp(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				}).removeClass('menu-open');
			} else {
				$(this).closest('.inner').addClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
				$(this).next().addClass('menu-open').slideDown(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				});
			}
		}
	});

      $('#js-open-menu').click(function(){
        $('.navigation.overlay').addClass('show');
    })

    $('.js-close-menu-mobile').click(function(){
        $('.navigation.overlay').removeClass('show');
    })

})();